import { createRouter, createWebHistory } from 'vue-router'

const routes = [
	{
		name: 'index',
		component: () => import("@/views/index/amazon-fba-cargo-damage-insurance.vue"),
		path: '/',
		meta: { layout: 'DefaultLayout' }
	},
	{
		name: 'purchase',
		component: () => import("@/views/purchase/amazon-fba-cargo-damage-insurance.vue"),
		path: '/purchase',
		meta: { layout: 'DefaultLayout' }
	},
	{
		name: 'checkout',
		component: () => import("@/views/checkout/amazon-fba-cargo-damage-insurance.vue"),
		path: '/checkout',
		meta: { layout: 'DefaultLayout' }
	},
	{
		path: '/:pathMatch(.*)*',
		redirect: {
			name: 'index'
		}
	}
]

const router = createRouter({
	history: createWebHistory(),
	routes
})

export default router 